import React from 'react';
import CategoriesImagesComponent   from '../components/CategoryImages';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const CategoriesImages = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Categorias</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item><Link to="/">Início</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/categories">Categorias</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Categorias Imagens</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <CategoriesImagesComponent  />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <CategoriesImagesComponent  />
        </Col>
      </Row>
    </div>
  );
};

export default CategoriesImages;